import type { SiteControllerSettingBaseFormModel } from "@/components/features/settings/site-controller/model/base/type";
import type { SiteControllerSettingBeds24FormModel } from "@/components/features/settings/site-controller/model/beds24/type";
import type { SiteControllerSettingBeds24FormModelMethodsType } from "@/components/features/settings/site-controller/model/beds24/use-case/use-create-model/methods";

import { SettingsSiteControllerBeds24PropAndApiKey } from "./prop-and-api-key";
import { SettingsSiteControllerBeds24RoomTypeMapping } from "./room-type-mapping";
import { SettingsSiteControllerBeds24SetUpRoomPriceByChillnn } from "./set-up-room-price-by-chillnn";
import { SettingsSiteControllerBeds24WebHookUrl } from "./web-hook-url";

type Props = {
	beds24ViewModel: SiteControllerSettingBeds24FormModel["ViewModel"];
	siteControllerSettingBeds24FormModelMethods: SiteControllerSettingBeds24FormModelMethodsType;

	roomKVList: SiteControllerSettingBaseFormModel["QueryData"]["roomKVList"];
};

export const SettingsSiteControllerBeds24MainSection = ({
	beds24ViewModel,
	siteControllerSettingBeds24FormModelMethods: _siteControllerSettingBeds24FormModelMethods,
	roomKVList,
}: Props) => {
	const { siteControllerSettingBeds24FormModelMethods } = _siteControllerSettingBeds24FormModelMethods;

	return (
		<>
			<SettingsSiteControllerBeds24PropAndApiKey
				beds24AuthenticationApiKey={beds24ViewModel.beds24AuthenticationApiKey}
				onSetBeds24AuthenticationApiKey={
					siteControllerSettingBeds24FormModelMethods.onSetBeds24AuthenticationApiKey
				}
				beds24AuthenticationPropKey={beds24ViewModel.beds24AuthenticationPropKey}
				onSetBeds24AuthenticationPropKey={
					siteControllerSettingBeds24FormModelMethods.onSetBeds24AuthenticationPropKey
				}
			/>
			<SettingsSiteControllerBeds24RoomTypeMapping
				roomKVList={roomKVList}
				beds24RoomTypeMapping={beds24ViewModel.beds24RoomTypeMapping}
				onSetBeds24RoomTypeMapping={siteControllerSettingBeds24FormModelMethods.onSetBeds24RoomTypeMapping}
				onSyncMasterData={siteControllerSettingBeds24FormModelMethods.onSyncMasterData}
				canSyncMasterData={siteControllerSettingBeds24FormModelMethods.canSyncMasterData}
			/>
			<SettingsSiteControllerBeds24WebHookUrl hotelID={beds24ViewModel.hotelID} />
			<SettingsSiteControllerBeds24SetUpRoomPriceByChillnn
				setUpRoomPriceByChillnn={beds24ViewModel.setUpRoomPriceByChillnn}
				onSetSetUpRoomPriceByChillnn={siteControllerSettingBeds24FormModelMethods.onSetSetUpRoomPriceByChillnn}
			/>
		</>
	);
};

SettingsSiteControllerBeds24MainSection.displayName = "SettingsSiteControllerBeds24MainSection";
